export enum IrisIconButtonTypes {
  DEPRESSED = 'depressed',
  RAISED = 'raised',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary'
}
